module.exports = __webpack_public_path__ + "img/big-circle.0b10a489.svg";